<template>
  <div>

    <b-form-group label-class="text-sm-left">
      <template slot="label">
        <!--title-->
        {{
          $t("label_evaluation_administrator_evaluations_selectOrganization")
        }}
      </template>
      <b-form-select
        id="label_evaluation_administrator_evaluations_selectOrganization"
        v-model="selectedBusiness"
        style="width: 100%"
      >
        <option :value="null" />
        <option
          v-for="(businessU, businessUIndex) of business"
          :key="businessUIndex"
          :value="businessU.id"
        >
          {{ businessU.name }}
        </option>
      </b-form-select>
    </b-form-group>
    <b-form-group label-class="text-sm-left">
      <template slot="label">
        <!--title-->
        {{ $t("label_evaluation_administrator_evaluations_selectSnapshot") }}
      </template>
      <b-form-select
        id="label_evaluation_administrator_evaluations_selectSnapshot"
        v-model="snapshotId"
        style="width: 100%"
      >
        <option :value="null" />
        <option
          v-for="(snapshot, snapshotIndex) of snapshots"
          :key="snapshotIndex"
          :value="snapshot.snapshotId"
        >
          {{ snapshot.date }}
        </option>
      </b-form-select>
    </b-form-group>
    <b-btn variant="primary" @click="cacheSnapshot()">
      {{ $t("Generar Cache") }}
    </b-btn>
    {{ action }}
  </div>
</template>
<script >
import { axiosCall } from "../utils/axiosCall";

export default {
  name: "SnapshotsCache",
  components: {},
  data: function () {
    return {
      snapshotId: null,
      business: null,
      selectedBusiness: null,
      snapshots: [],
      action: "",
    };
  },
  watch: {
    selectedBusiness: {
      handler: function (newVal) {
        if (newVal) {
          this.action = "";
          axiosCall({ url: "Snapshots/list/" + newVal, method: "GET" }).then(
            (response) => {
              this.snapshots = response.data.snapshots;
            }
          );
          this.selectedBusiness = newVal;
        } else {
          this.snapshots = [];
        }
      },
    },
  },
  created() {
    this.getCreationData();
  },
  methods: {
    async getCreationData() {
      await axiosCall({
        url: "EvaluationModels/getDataForCreation",
        method: "GET",
      }).then((response) => {
        this.business = response.data.business;
        this.business.sort((a, b) => {
          if (a.name > b.name) {
            return 1;
          }
          if (b.name > a.name) {
            return -1;
          }
          return 0;
        });
      });
    },
    cacheSnapshot() {
      this.action = "Generando Caché...";
      axiosCall({ url: "Snapshots/close/" + this.snapshotId, method: "GET" })
        .then(() => {
          this.action = "OK!";
        })
        .catch((error) => {
          this.action = "Error!" + error;
        });
    },
  },
};
</script >

<style lang="sass" scoped >


</style >
